import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const TABS = [
  { to: 'permissions', label: 'Permissions', module: 'settings_permissions' },
  { to: 'users',       label: 'Users',       module: 'settings_users' },
  { to: 'clients',     label: 'Clients',     module: 'settings_clients' },
];

export default function SettingsLayout() {
  return (
    <div className="flex flex-col h-full">
      <div className="px-6 pt-4 border-b border-surface-border dark:border-surface-dark-border">
        <h1 className="text-lg font-semibold mb-3">Settings</h1>
        <nav className="flex gap-1 -mb-px overflow-x-auto">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                'px-3 py-2 text-sm rounded-t-thin border-b-2 -mb-px whitespace-nowrap ' +
                (isActive
                  ? 'border-continuum-500 text-continuum-700 dark:text-continuum-200 font-medium'
                  : 'border-transparent text-surface-text dark:text-surface-dark-text hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle')
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
